import {
  usePlayersStore,
  useVotingStore,
} from "@/stores";
export function handleVote([index, vote, fromST]: [number, number, boolean]) {
  const votingStore = useVotingStore();
  const playersStore = usePlayersStore();
  const playerCount = playersStore.players.length;
  const indexAdjusted =
    (index -
      1 +
      playerCount -
      (typeof votingStore.nomination?.nominee === "number"
        ? votingStore.nomination.nominee
        : (votingStore.nomination?.nominator as number) || 0)) %
    playerCount;
  if (fromST || indexAdjusted >= votingStore.lockedVote - 1) {
    votingStore.handleVote([index, vote]);
  }
}
